import React from 'react'
import {Col, Row} from "antd";
import LadderImg from '../../../images/market/groupBuy/groupBuyLadder.svg'
class FunnelLadderGroup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        if (this.props.data) {
            this.setState({
                data: this.props.data
            })
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (JSON.stringify(this.props.data) != JSON.stringify(nextProps.data)) {
            this.setState({
                data: nextProps.data
            })
        }
    }

    render() {
        let data = this.state.data;
        if (data) {
            return (
                <div className={'groupLadder'}>
                    <ul className="funnelLadder group" style={{'width':'50%'}}>
                        <li style={{backgroundColor: '#D5F5E8'}} className={'first-group-li'}>
                            <Row>
                                <Col span={12}>
                                    <div className='funnelLadder-item'>
                                        <p>{data.itemList[0].labelText}</p>
                                        <label>{data.itemList[0].value}</label>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div className='funnelLadder-item'>
                                        <p>{data.itemList[1].labelText}</p>
                                        <label>{data.itemList[1].value}</label>
                                    </div>
                                </Col>
                            </Row>
                        </li>
                        <li style={{backgroundColor: '#FCEEC3'}} className={'second-group-li'}>
                            <Row>
                                <Col span={12}>
                                    <div className='funnelLadder-item'>
                                        <p>{data.itemList[2].labelText}</p>
                                        <label>{data.itemList[2].value}</label>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div className='funnelLadder-item'>
                                        <p>{data.itemList[3].labelText}</p>
                                        <label>{data.itemList[3].value}</label>
                                    </div>
                                </Col>
                            </Row>
                        </li>
                        <li style={{backgroundColor: '#FBE5E0'}} className={'third-group-li'}>
                            <Row>
                                <Col span={12}>
                                    <div className='funnelLadder-item'>
                                        <p>{data.itemList[4].labelText}</p>
                                        <label>{data.itemList[4].value}</label>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div className='funnelLadder-item'>
                                        <p>{data.itemList[5].labelText}</p>
                                        <label>{data.itemList[5].value}</label>
                                    </div>
                                </Col>
                            </Row>
                        </li>
                    </ul>
                    <div className={'funnelLadderGroup-img'}>
                        <img src={LadderImg}/>
                        <ul className={'funnelLadder group'} style={{'width':'29%'}}>
                            <li style={{backgroundColor: '#D5F5E8'}} className={'first-group-li'}></li>
                            <li style={{backgroundColor: '#FCEEC3'}} className={'second-group-li'}></li>
                            <li style={{backgroundColor: '#FBE5E0'}} className={'third-group-li'}></li>
                        </ul>
                        <div className='groupRate'>
                            <div className='funnelLadderG-rate funnelLadderG-rate1'>
                                <p>{data.rate2.labelText}</p>
                                <p>{data.rate2.value}</p>
                            </div>
                            <div className='funnelLadderG-rate funnelLadderG-rate2'>
                                <p>{data.rate1.labelText}</p>
                                <p>{data.rate1.value}</p>
                            </div>
                            <div className='funnelLadderG-rate funnelLadderG-rate3'>
                                <p>{data.rate3.labelText}</p>
                                <p>{data.rate3.value}</p>
                            </div>
                        </div>


                    </div>
                </div>
            )
        } else {
            return '';
        }
    }
}

export default FunnelLadderGroup;